import React, { Fragment, } from 'react';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Button, Box, Typography } from '@material-ui/core';
import { marginBottom } from "../../../config/styles";
import { invokePostService, setDashboardRefresh, setReRender, toggleRightDrawer } from "../../../store/global/actions";
import { editView } from "../../../store/views/actions";
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { getDetailsFromUrl } from '../../../services/blueprint'
import { useHistory } from 'react-router-dom';
import { updateViewSchema } from '../../../utils/DashboardBuilder';

export default function DeleteAction(props) {
    const { onClose, onCompletion, view, updatedWidget } = props;

    const dispatch = useDispatch();
    const history = useHistory();

    const rightDrawerStatus = useSelector(getRightDrawerStatus);

    const [isLoading, setLoading] = useState(false);
    const onDelete = () => {
        setLoading(true);
        dispatch(setDashboardRefresh({ type: "widget", action: "edit", entity: {id:updatedWidget.id,  ...updatedWidget} }));
        const updatedView = updateViewSchema(view, 'edit', { id: updatedWidget.id, updatedData: updatedWidget });
        dispatch(invokePostService('updateView', { view: updatedView }, [view._id])).then(response => {
            setLoading(false);
            if (response.status === true) {
                dispatch(editView(updatedView));
                onCompletion();
            } else {
                if (response.code === 255) {
                    if (rightDrawerStatus === true) dispatch(toggleRightDrawer());
                    const { slug, blueprintId } = getDetailsFromUrl();
                    history.push(`/blueprint/${slug}/${blueprintId}/system-model`);
                    dispatch(setReRender());
                    onCompletion();
                }
            }
        });
    }

    return (
        <>
            <Box>

                <Grid xs={12} style={marginBottom}>
                    <Fragment>
                        <Typography> {`Are you sure you want to delete the action ?`} </Typography>
                    </Fragment>
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <Button onClick={onClose} color="primary" variant="outlined" style={{ textTransform: 'capitalize', marginLeft: 10 }}>
                        Cancel
                    </Button>
                    <Button onClick={onDelete} disabled={isLoading} color="secondary" variant="contained" style={{ textTransform: 'capitalize', marginLeft: 10 }}>
                        {isLoading ? 'Deleting..' : 'Delete'}
                    </Button>
                </Grid>

            </Box>
        </>
    )
}